<div class="signature-container">
    <canvas #signaturePad class="signature-pad"></canvas>
    <div class="signature-buttons">
        <button type="button" (click)="clearSignature()">Clear</button>
        <button type="button" (click)="saveSignature()">Save</button>
    </div>
    <p *ngIf="signatureError" class="signature-error" role="alert">{{ signatureError }}</p>
</div>
